// extracted by mini-css-extract-plugin
export default {"your_rd":"hy","title":"iy","subtitle":"jy","rd_bio_wrapper":"ky","rd_text_mobile":"ly","rd_bio":"my","img":"ny","rd_info":"oy","rd_name":"py","rd_stat":"qy","rd_text":"ry","btn_mobile":"sy"};
    if(module.hot) {
      // 1715188235776
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  